import { Link } from "react-router-dom";
import { CustomComponentProps } from "utils/types/general.types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { blockedPNG, deletedPNG } from "utils/assets_exports/images";
import { DemoUserListObject } from "assets/data/usersData";
import { Card, UserDashboardPopover } from "ui";

export type UserListProps = CustomComponentProps & {
    listItem: DemoUserListObject;
    isOnline?: boolean;
    handleDelete: (id: string | number) => void;
    handleBlock: (id: string | number) => void;
    handleRestore: (id: string | number) => void;
    handleSendMsg: (user: DemoUserListObject) => void;
};

// const items: string[] = ["View", "Block", "Delete"];

const UserList = ({
    listItem,
    handleBlock,
    handleDelete,
    handleRestore,
    handleSendMsg,
    isOnline = false,
    className,
    style
}: UserListProps) => {
    return (
        <>
            {/* <Card className={`${className}`} style={style}> */}
            {/* {{ ...style, height: "300px" }} */}
            <div className={` ${className}`} style={style}>
                <Card className="flex flex-col gap-3 justify-between items-center relative dark:text-white">
                    {/* <div className="flex justify-end w-full"> */}
                    <div className="my-drop-down absolute top-0 right-0 p-1 w-fit">
                        <MoreVertIcon
                            fontSize="medium"
                            className="my-drop-down-more-vertical dark:text-white"
                        />
                        <div
                            className={`my-drop-down-div right bg-neutral-100 dark:bg-momeento-300 rounded`}
                        >
                            <ul>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                >
                                    <Link
                                        to={`/users/view/${listItem.id}`}
                                        className="w-full block"
                                    >
                                        View
                                    </Link>
                                </li>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                    onClick={() => {
                                        if (listItem.status === "blocked") {
                                            handleRestore(listItem.id);
                                        } else {
                                            handleBlock(listItem.id);
                                        }
                                    }}
                                >
                                    {listItem.status === "blocked"
                                        ? "Unblock"
                                        : "Block"}
                                </li>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                    onClick={() => {
                                        if (listItem.status === "deleted") {
                                            handleRestore(listItem.id);
                                        } else {
                                            handleDelete(listItem.id);
                                        }
                                    }}
                                >
                                    {listItem.status === "deleted"
                                        ? "Restore"
                                        : "Delete"}
                                </li>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                    onClick={() => handleSendMsg(listItem)}
                                >
                                    Message
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* </div> */}

                    <UserDashboardPopover
                        user={listItem}
                        isOnline={isOnline}
                        className="big-avatar center-pop-over"
                    />
                    {listItem.status !== "active" && (
                        <div className="absolute top-0 left-0 p-1">
                            <img
                                src={
                                    listItem.status === "blocked"
                                        ? blockedPNG
                                        : deletedPNG
                                }
                                alt="blocked"
                                style={{ width: "60px" }}
                            />
                        </div>
                    )}
                    <h3 className="text-md font-semibold">
                        <Link to={`/users/view/${listItem.id}`}>
                            {listItem.name}
                        </Link>
                    </h3>
                    <p>From: India</p>

                    <div className="flex w-full justify-between items-center">
                        <span>31 March 2024</span>
                        <span>IOS</span>
                    </div>
                </Card>

                {listItem.status !== "active" && (
                    <div className="w-full flex mt-3 justify-center">
                        <button
                            className="px-5 py-1 bg-momeento-50 hover:shadow-lg focus:shadow-lg text-white rounded-full"
                            onClick={() => handleRestore(listItem.id)}
                        >
                            restore
                        </button>
                    </div>
                )}
            </div>
            {/* </Card> */}
        </>
    );
};

export default UserList;
